import React, { FunctionComponent } from 'react';

import { DateTimeFieldType } from '../../types';
import { TextField } from '.';
import { TextFieldTypeEnum } from '../../enums';

const DateTimeField: FunctionComponent<DateTimeFieldType> = (props) => {
  return <TextField {...props} type={TextFieldTypeEnum.DATETIME} />;
};

export default DateTimeField;
